export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const APP_URL = process.env.REACT_APP_URL;
export const APP_SECRET = process.env.REACT_APP_APP_SECRET;
export const S3_BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME;
export const ENV=process.env.REACT_APP_ENV;
export const S3_BUCKET_REGION = process.env.REACT_APP_S3_BUCKET_REGION;
export const IDENTITY_POOL_ID = process.env.REACT_APP_IDENTITY_POOL_ID;
export const PAYPAL_AUTH_HASH = process.env.REACT_APP_PAYPAL_AUTH_HASH;
export const PAYPAL_REDIRECT_URL = process.env.REACT_APP_PAYPAL_REDIRECT_URL;
export const PAYPAL_APP_ID =  process.env.REACT_APP_PAYPAL_APP_ID;
export const BRAINTREE_CLIENT_TOKEN =  process.env.REACT_APP_BRAINTREE_CLIENT_TOKEN;
export const MIN_DESKTOP_WIDTH = 1024; //in pixels
export const IMAGE_SIZE_LIMIT_BYTES = 5000000;
export const VIDEO_SIZE_LIMIT_BYTES = 10000000;
export const MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES = 10000000;
export const TOPIC_VIDEO_SIZE_LIMIT_BYTES = 80000000;

let PAYPAL_AUTH_POINT;
if (ENV === 'prod') {
    PAYPAL_AUTH_POINT = 'https://www.paypal.com/connect?flowEntry=static';
} else {
    PAYPAL_AUTH_POINT = 'https://www.sandbox.paypal.com/connect?flowEntry=static';
}
export {PAYPAL_AUTH_POINT};
export const URL_PATTERN =  /^((http|https):\/\/)/;
export const MESSAGES = {
    SELECT_VIDEO_OR_IMAGE: 'Please select a video or image for the cover',
    IMAGE_COVER: 'Please select an image for the cover.'
}
export const APP_LINK = {
    IOS: 'https://apps.apple.com/tt/app/fitbanx/id1501282616?ign-mpt=uo%3D2',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.fitbanxmobile'
}
export const GENERAL_HELP_CONTENT = [
    {
        text:'General overview',
        videoId:'MXEgD8FlJeo'
    },
    {
        text:'All about partners',
        videoId:'9sHyYIp0bAA'
    },
    {
        text:'How to build workouts?',
        videoId:'TpMBuOLq6rc'
    },
    {
        text:'How to build programs?',
        videoId:'2MTCKXFFnNY'
    },
    {
        text:'How to build blocks?',
        videoId:'Mfuo3aHWha8'
    },
    {
        text:'How to make edits to workouts, programs, blocks, and exercises?',
        videoId:'vKZMMYuEF4I'
    },
    {
        text:'How to make a great exercise video?',
        videoId:'voBfUaZn0BU'
    },
    {
        text: 'How to edit and upload exercise videos?',
        videoId: 'X7Kd81NVqXk'
    },
    {
        text:'How to add rest intervals after circuit rounds?',
        videoId:'Zs414FeIyVQ'
    },
    {
        text:'About the tempo timer feature',
        videoId:'PrlAfzXQYXY'
    },
    {
        text:'About the AMRAP (as many rounds as possible) feature',
        videoId:'BMXlEcStb4U'
    },
    {
        text:'How to assign workouts to clients and how to assign workouts to your partner channel?',
        videoId:'4HPi1-fYFd4'
    }
];

export const STRIPE_USER = `stripe_user[url]=${process.env.REACT_APP_URL}`;

export const STRIPE_HELP_VIDEO_LINK = '6KzIkbG7jjQ'

export const NUMBER = {
    ZERO: 0,
    TWENTY: 20,
    TEN: 10,
    ONE: 1
 }

export const PLANOPTION = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5
}



// WEBPACK FOOTER //
// ./src/constants.js